// import { List, ListItem, ListItemText, ListItemIcon } from "@material-ui/core";
// import React from "react";

// import { Container, Grid, Paper } from "@material-ui/core";
// import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
// import { Divider } from "@material-ui/core";

// import { useNavigate } from "react-router-dom";
// import ItemCard from "../cards/ItemCard";
// function PromoItemList(props) {
//   const nav = useNavigate();
//   const handleClick =
//     (id) =>
//     ({ getItemById, scrollToItem }) => {
//       nav(`/item/${id}`);
//     };
//   return (
//     <div>
//       <Container style={{ margin: "auto", marginTop: "8px" }}>
//         <Grid container>
//           {props.promo.map((item) => (
//             <Grid
//               item
//               key={item._id}
//               xs={12}
//               sm={6}
//               md={4}
//               lg={3}
//               style={{ display: "flex", justifyContent: "center" }}
//             >
//               <ItemCard
//                 item={item}
//                 style={{ width: "200px" }}
//                 handleCart={props.handleCart}
//                 last={item === props.promo[parseInt(props.promo.length) - 1]}
//               />
//             </Grid>
//           ))}
//         </Grid>
//       </Container>
//     </div>
//     /* <div className="promo_list">
//         {props.promo.map((item) => {
//           return <div key={item._id} className="promo_item" onClick={handleClick(item._id)}>
//             <h3>{item.name}</h3>
//             <img src={`http://196.189.44.49:7000/$item.image_url[0]`}/>
//             <h5>{item.price} birr</h5>
//             <p>{item.details}</p>
//           </div>
//         })
//         }
//         </div> */
//     /* <List>
//         {props.promo.map((item) => {
//           return <ListItem key={item._id}>
//               <ListItemText primary={item.name}/>
//               <ListItemIcon>{`http://196.189.44.49:7000/$item.image_url[0]`}</ListItemIcon>
//           </ListItem>
//         })
//         }
//         </List> */
//   );
// }

// export default PromoItemList;
import React from "react";
import { Container } from "@material-ui/core";
import { ScrollMenu } from "react-horizontal-scrolling-menu";
import { useNavigate } from "react-router-dom";
import ItemCard from "../cards/ItemCard";

function PromoItemList(props) {
  const nav = useNavigate();

  const handleClick =
    (id) =>
    ({ getItemById, scrollToItem }) => {
      nav(`/item/${id}`);
    };

  return (
    <div>
      <Container style={{ margin: "auto", marginTop: "8px" }}>
        <ScrollMenu
          style={{
            display: "flex",
            overflowX: "auto",
            padding: "10px 0",
            whiteSpace: "nowrap", // Keeps items in a single line
          }}
        >
          {props.promo.map((item) => (
            <div
              key={item._id}
              style={{
                margin: "0 10px",
                display: "inline-block",
                minWidth: "200px",
                // borderRadius: "100px",
                // Ensures each item has a minimum width
              }}
            >
              <ItemCard
                item={item}
                handleCart={props.handleCart}
                last={item === props.promo[props.promo.length - 1]}
              />
            </div>
          ))}
        </ScrollMenu>
      </Container>
    </div>
  );
}

export default PromoItemList;
